/**
 * Model for mastery grade policy
 */
export default class MasteryGradePolicy {
  get isMastery() {
    return true;
  }

  get isCumulative() {
    return false;
  }

  get isPassingThresholdValid() {
    return true;
  }

  clone = () => new MasteryGradePolicy();

  toJSON() {
    return {
      'org.coursera.ondemand.coursematerial.MasteryGradePolicy': {},
    };
  }
}
